<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="showTitle">Users</span>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          autocomplete="off"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showDense">
          <v-row>
            <v-col>
              <v-checkbox label="Dense" v-model="dense"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-data-table
          :items="items"
          :headers="headers"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="footerProps"
          :dense="dense"
        >
          <!-- <template slot="items" slot-scope="props">
            <td v-for="(header, index) in headers" :key="index">
              <span>{{ props.item[header.value] }}</span>
              <span v-if="typeof props.item[header.value] === Boolean ">Yeah</span>
            </td>
          </template>-->

          <template v-slot:item.action="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
          <template v-slot:item.isActive="{ item }">
            <v-icon :color="item.isActive ? 'success' : 'grey'" dark
              >mdi-circle</v-icon
            >
          </template>
          <template v-slot:item.isLocked="{ item }">
            <v-icon color="warning" dark v-if="item.isLocked">mdi-lock</v-icon>
            <v-icon color="info" dark v-else>mdi-lock-open</v-icon>
          </template>
          <template v-slot:item.expirationDate="{ item }">
            <span>{{ item.expirationDate | dateFormat }}</span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <slot name="card-actions"></slot>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { isNullOrUndefined } from "../../../validation/validation";
const API_ENDPOINT = "/api/users";

export default {
  props: {
    showTitle: {
      default: true,
      type: Boolean,
    },
    showDense: {
      default: true,
      type: Boolean,
    },
    headers: {
      default: () => [
        {
          text: "",
          sortable: false,
          value: "action",
        },
        {
          text: "Active",
          value: "isActive",
        },
        {
          text: "Is Locked",
          sortable: false,
          value: "isLocked",
        },
        {
          text: "Emp Code",
          align: "left",
          sortable: false,
          value: "empCode",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "fullName",
        },
        {
          text: "Username",
          align: "left",
          sortable: false,
          value: "username",
        },
        {
          text: "Expiration Date",
          align: "left",
          sortable: false,
          value: "expirationDate",
        },
      ],
      type: Array,
    },
  },
  data: () => ({
    items: [],
    search: "",
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100],
    },
    loading: false,
    dense: false,
  }),
  methods: {
    getAll() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getAllPaginatedList() {
      this.loading = true;
      if (!isNullOrUndefined(this.search))
        this.pagination = { page: 1, itemsPerPage: 10 };

      const { page, itemsPerPage } = this.pagination;

      this.$axios
        .get(
          `${API_ENDPOINT}/pagination?pageNum=${page}&pageSize=${itemsPerPage}&query=${this.search}`
        )
        .then(({ data }) => {
          this.items = data.users;
          this.totalItems = data.totalData;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAllPaginatedList();
  },
  watch: {
    pagination(val, oldVal) {
      if (JSON.stringify(val) != JSON.stringify(oldVal))
        this.getAllPaginatedList();
    },
    search() {
      this.getAllPaginatedList();
    },
  },
};
</script>
